import { Grid, Paper } from "@mui/material";
import { GridReadyEvent } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useRef } from "react";
import { BilletsYardStatistics } from "../../models/BilletsYardStatistics";
import { useStatisticsColumns } from "../hooks/useStatisticsColumns";
import { useResize } from "@/utils/useResize";
import { getResponsiveTableStyles } from "@/utils/responsive-utils";
import { defaultColDef, defaultGridOptions } from "@/setup/ag-grid/mesf-theme";

type Props = {
  loadingGrid: boolean;
  rows: BilletsYardStatistics[];
  onGridReady?: (params: GridReadyEvent) => void;
};

export const BilletsYardStatisticsTable = ({
  loadingGrid,
  rows,
  onGridReady,
}: Props) => {
  const gridRef = useRef<AgGridReact>(null);
  const { width, height } = useResize();
  const tableStyles = getResponsiveTableStyles(width, height);

  const { columns } = useStatisticsColumns();

  return (
    <>
      <Grid container>
        <Grid
          item
          component={Paper}
          elevation={3}
          md={12}
          xs={12}
          style={tableStyles}
        >
          <AgGridReact
            ref={gridRef}
            rowData={rows}
            columnDefs={columns}
            defaultColDef={defaultColDef}
            loading={loadingGrid}
            onGridReady={onGridReady}
            {...defaultGridOptions}
          />
        </Grid>
      </Grid>
    </>
  );
};
